module.exports = __webpack_public_path__ + "static/media/Screenshot_10-thumb.7235f303.png";